import update from 'immutability-helper'

const getInitialState = () => {
  const showConnectionsString = window.localStorage.getItem('showConnections')
  const showAllConnectionsString =
    window.localStorage.getItem('showAllConnections')
  const showLeftNavLabelsString =
    window.localStorage.getItem('showLeftNavLabels')

  // Default to showing all connections (both true)
  const showConnections = showConnectionsString
    ? JSON.parse(showConnectionsString)
    : true

  const showAllConnections = showAllConnectionsString
    ? JSON.parse(showAllConnectionsString)
    : true

  // Default to showing left nav labels
  const showLeftNavLabels = showLeftNavLabelsString
    ? JSON.parse(showLeftNavLabelsString)
    : true

  return {
    showConnections,
    showAllConnections,
    showLeftNavLabels,
  }
}

// TYPES
export const TOGGLE_CONNECTIONS = Symbol('TOGGLE_CONNECTIONS')
export const TOGGLE_ALL_CONNECTIONS = Symbol('TOGGLE_ALL_CONNECTIONS')
export const TOGGLE_LEFT_NAV_LABELS = Symbol('TOGGLE_LEFT_NAV_LABELS')

// REDUCER
export default (state = getInitialState(), action) => {
  switch (action?.type) {
    case TOGGLE_CONNECTIONS: {
      const showConnections = !state.showConnections

      // update localStorage with the new value
      window.localStorage.setItem('showConnections', showConnections)

      // If turning off connections, also turn off showAllConnections
      const updates = showConnections
        ? { showConnections }
        : { showConnections, showAllConnections: false }

      if (!showConnections) {
        window.localStorage.setItem('showAllConnections', false)
      }

      return update(state, { $merge: updates })
    }

    case TOGGLE_ALL_CONNECTIONS: {
      const showAllConnections = !state.showAllConnections

      window.localStorage.setItem('showAllConnections', showAllConnections)

      return update(state, { $merge: { showAllConnections } })
    }

    case TOGGLE_LEFT_NAV_LABELS: {
      const showLeftNavLabels = !state.showLeftNavLabels

      window.localStorage.setItem('showLeftNavLabels', showLeftNavLabels)

      return update(state, { $merge: { showLeftNavLabels } })
    }

    default:
      return state
  }
}

// ACTIONS
export const toggleConnections = () => ({ type: TOGGLE_CONNECTIONS })
export const toggleAllConnections = () => ({ type: TOGGLE_ALL_CONNECTIONS })
export const toggleLeftNavLabels = () => ({ type: TOGGLE_LEFT_NAV_LABELS })

// SELECTORS
export const getShowConnections = state => {
  return state.settings.showConnections
}

/**
 *
 * @param {*} state
 * @returns {boolean}
 */
export const getShowAllConnections = state => {
  return state.settings.showAllConnections
}

export const getShowLeftNavLabels = state => {
  return state.settings.showLeftNavLabels
}
